import { render, staticRenderFns } from "./OpenExchanges.vue?vue&type=template&id=5e8e2996"
import script from "./OpenExchanges.vue?vue&type=script&lang=js"
export * from "./OpenExchanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports